import React from 'react';
import { observer } from 'mobx-react';
import { Dialog, DialogProps } from '@mui/material';
import { useGamix } from '@gamiphy/loyalty/components/framePortal';

const Popup: React.FC<DialogProps> = observer((props) => {
  const { container } = useGamix();

  return (
    <Dialog
      container={container}
      {...props}
    />
  );
});

export default Popup;
